import { ACCOUNT_STATUS, IBrandUser, IEditBrandUser } from "@shared/lib/types";
import styles from "../styles.module.scss";
import { Notes } from "@shared/ui/Note/Note";
import { useEditBrandUser } from "@entities/brand/lib/hooks/useEditBrandUser";
import { AgencyUserCard } from "./AgencyUserCard";
import { useEffect, useState } from "react";
import { Modal, Space, Switch } from "antd";
import { BrandUserUpdateForm } from "@entities/brand/ui/BrandUserUpdateForm";
import { Permissions } from "./Permissions";
import { AgencyUser } from "@shared/lib/types/agency";
import ContactForm from "@entities/agency/ui/ContactList/ContactForm";
import { useEditAgencyUser } from "@entities/agency/lib/hooks/useEditAgencyUser";
import { ToastService } from "@shared/lib/services";

interface Props {
  agencyId: string;
  agencyUser: AgencyUser;
  onSuccess: () => void;
}
export function ManageAgencyUser({ agencyId, agencyUser, onSuccess }: Props) {
  const { editAgencyUser, isEdited, isEditing } = useEditAgencyUser();

  // const handleSubmit = (brandData: Partial<IEditBrandUser>) => {
  //   updateBrandUser({
  //     agencyUser: brandData,
  //     agencyUserId: agencyUser.userId,
  //   });
  // };

  const handleContact = (values: AgencyUser) => {
    return editAgencyUser({
      agencyId,
      agencyUser: {
        ...values,
        agencyUserId: agencyUser.agencyUserId,
      },
    });
  };

  const [modalVisible, setModalVisible] = useState<boolean>(false);

  useEffect(() => {
    if (isEdited) {
      ToastService.success("Agency User Updated");
      setModalVisible(false);
      onSuccess();
    }
  }, [isEdited]);

  return (
    <>
      <div className={styles.container}>
        {/* <Notes
          handleSubmit={(value) => handleSubmit({ note: value })}
          isSubmiting={isUpdatingBrandUser}
          value={agencyUser?.notes?.note || ""}
        /> */}
        <AgencyUserCard
          agencyUser={agencyUser}
          handleEditClick={() => setModalVisible(true)}
        />
        <Permissions
          agencyId={agencyId}
          agencyUser={agencyUser}
          onSuccess={onSuccess}
        />
      </div>
      <Modal
        title={"Edit Agency User"}
        open={modalVisible}
        onCancel={() => {
          setModalVisible(false);
        }}
        footer={null}
        destroyOnClose
      >
        <ContactForm
          isSubmitting={isEditing}
          onSubmit={handleContact}
          initialValues={agencyUser}
          initialRoles={[]}
        />
      </Modal>
    </>
  );
}
